export default function(number: number): string {
  try {
    return number.toString().replaceAll(/\B(?=(\d{3})+(?!\d))/g, ",");
  } catch (e) {
    return "";
  }
}
